import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsumeCredencialesService {
  URL_REST : string = environment.url_api
  constructor(
              private http : HttpClient
  ) { }

  /**
   * @description funcion que se encarga de consumir recurso por el metodo post al back de credenciales
   * @param recurso recurso que se consumira en credenciales
   * @param params parametros de la peticion a realizar
   */
  public post(recurso : string, params :any){
    return this.http.post(this.URL_REST+ recurso, params);
  }

  /**
   * @description funcion que se encarga de consumir recurso por el metodo PUT al back de credenciales
   * @param recurso recurso que se consumira en credenciales
   * @param params parametros de la peticion a realizar 
   */
  public put(recurso : string, params : any ){
    return this.http.put(this.URL_REST+recurso, params);
  }

  /**
   * @description funcion que se encarga de consumir recurso por el metodo PUT al back de credenciales
   * @param recurso recurso que se consumira en credenciales
   * @param params parametros de la peticion a realizar 
   */
  public get(recurso : string, params : HttpParams = new HttpParams()){

    return this.http.get(this.URL_REST+recurso, {params});
  }
  
}
